import { KYMW4200Model } from '../kymw4200.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 商品マスタプルーフ帳票を出力する
 *
 * @export API通信成功時の処理
 * @class OutputGoodsMasterProofService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class OutputGoodsMasterProofService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel および Vo
  private model: KYMW4200Model;
  private voList: Array<any> = new Array<any>();
  successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof OutputGoodsMasterProofService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        GoodsList: {
          combination: this.voList.map(vo => {
            return {
              condition: {
                PCode: vo.PCode,
                ItemCode: vo.ItemCode
              }
            }
          })
        }
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param {*} model
   * @param {*} voList
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof OutputGoodsMasterProofService
   */
  execute(model: any, voList: any, successFunc: Function = null) {
    this.model = model;
    this.voList = voList;
    this.successFunc = successFunc;
    this.send('KYMW42outputGoodsMasterProof', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof OutputGoodsMasterProofService
   */
  success(data: any) {
    this.model.updateFileUrl(data);

    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
